module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-Italic_1_80e76c21.9a214599.woff";